import { mapActions, mapMutations, mapGetters } from 'vuex';
import {
  LOGIN,
  LOGOUT,
  ACCOUNT
} from '../stores/types';

const isDef = y => typeof y !=='undefined';

function deepFind(query, array, opts) {
    opts = { subField: 'children' };
    var result;
    for (let i = 0; i < array.length; i++) {
        const item = array[i];
        for (const key in query) {
            if (item[key] == query[key]) {
                result = item;
            } else if (isDef(item[opts.subField])) {
                result = deepFind(query, item[opts.subField], opts);
            }
            if (typeof result != 'undefined') break;
        }
        if (typeof result != 'undefined') break;
    }
    return result;
}

export const common = {
    methods: {
        $$deepFind(...arg){
            return deepFind(...arg);
        }
    }
}

export const auth = {
  computed: {
    ...mapGetters({account:ACCOUNT})
  },
  methods: {
    ...mapActions([LOGIN, LOGOUT]),
    async $$login(account) {
      this.$ivLoading.start();
      // this.$$loading();
      try {
        await this[LOGIN](account);
        this.$ivLoading.finish();
        // this.$$loaded();
        this.$router.replace({ name: 'target' });
      } catch (e) {
        this.$$error(e);
        this.$ivLoading.error();
        // this.$$loaded();
      }
      this.$ivLoading.finish();
    },
    async $$logout() {
      this.$ivLoading.start();
      // this.$$loading();
      try {
        await this[LOGOUT]();
      } catch (e) {
        console.error(e);
      }
      this.$ivLoading.finish();
      this.$router.replace({ name: 'login', query:{redirect: this.$route.fullPath} });
      // this.$$loaded();
    }
  }
}

export const message = {
    data() {
        return {
            'messageQueues': []
        }
    },
    beforeDestroy() {
        while (this.messageQueues.length > 0) {
            let $message = this.messageQueues.pop();
            $message();
        }
    },
    methods: {
        $$onError(e, { duration }) {
            const unauthorized = ['RequestError','BusinessError'].indexOf(e.name)>-1 && e.code == 401;
            // 失效跳转暂时关闭
            if (unauthorized){
              if(this.$route.name !== 'login') return this.$loginModal.show();
              this.$ivMessage[e.type || 'error']({
                  content: e.message,
                  duration
              })
          }else{
              this.$ivMessage[e.type || 'error']({
                  content: e.message,
                  duration
              })
          }
        },
        $$error(e, duration = 3) {
            if (['BusinessError'].indexOf(e.name) < 0){
                console.error(e);
            }
            this.$$onError(e, { duration });
        },
        $$warning(options) {
            if (typeof options === 'string') options = { content: options };
            options = { duration: 1.5, ...options };
            this.$ivMessage.warning(options);
        },
        $$info(options) {
            if (typeof options === 'string') options = { content: options };
            options = { duration: 1.5, ...options };
            this.$ivMessage.info(options);
        },
        $$success(options) {
            if (typeof options === 'string') options = { content: options };
            options = { duration: 1.5, ...options };
            this.$ivMessage.success(options);
        },
        $$confirm(options) {
            if (typeof options === 'string') options = { content: options };
            options = { title: "询问", ...options };
            return new Promise((resolve, reject) => {
                try {
                    this.$ivModal.confirm({
                        title: options.title,
                        content: options.content,
                        onOk: () => { resolve(true) },
                        onCancel: () => { resolve(false) }
                    });
                } catch (e) {
                    reject(e);
                }
            })
        }
    }
};
